import debounce from 'lodash/debounce';
import { setMaxHeightStyle } from '../../../scripts/utils/setMaxHeightStyle';

function initCollapsibleBlocks() {
  const collapsibleContainers = document.querySelectorAll(
    '[data-collapsible-container]'
  );
  const controlButtons = document.querySelectorAll('[data-control-button]');
  const sectionImages = document.querySelectorAll('[data-section-image]');
  const hiddenCollapsibleClassName =
    'pro-multifamily-experience-automate-utilities__content-item--hidden';
  const hiddenImageClassName =
    'pro-multifamily-experience-automate-utilities__image--hidden';

  controlButtons.forEach((el, index) => {
    el.addEventListener('click', () => {
      const elParent = el.closest('[data-collapsible-container]');

      if (elParent.classList.contains(hiddenCollapsibleClassName)) {
        collapsibleContainers.forEach((e) => {
          e.classList.add(hiddenCollapsibleClassName);
        });
        sectionImages.forEach((image) => {
          image.classList.add(hiddenImageClassName);
        });
        elParent.classList.remove(hiddenCollapsibleClassName);
        sectionImages[index].classList.remove(hiddenImageClassName);
      }
    });
  });
}

function setCollapsibleBlocksHeight() {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle('[data-automate-utilities-collapsible]');
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
}

initCollapsibleBlocks();
setCollapsibleBlocksHeight();
